import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { InputType } from '../../../../../../common/components/reactive-form-builder/interfaces/input.interface';
import { TareaPiscinasModel } from '../../../../../../models/tareas/tarea-piscinas.model';
import { MtoReactiveFormDefinition, MtoSectionSpec } from '../../../mto-reactive/mto-reactive-form-definition';

export class TareasMtoPiscinasFormDefinition extends MtoReactiveFormDefinition<TareaPiscinasModel> {
    constructor(type: FormType = FormType.CREATION, model: Partial<TareaPiscinasModel> = {}) {
        super(type, model);

        this.initializeMtoForm({
            name: 'piscinas',
            header: 'Datos de piscinas',
            database: 'tareas_mto_piscinas',
            signatureFolder: 'piscinas',
            sections: this.getSections(),
        });
    }

    private getSections(): MtoSectionSpec<TareaPiscinasModel>[] {
        return [
            { name: 'Datos de piscinas', fields: [...this.getDefaultMainFieldSpecs()] },
            { name: 'Tareas de piscina', fields: [
                this.field('barredera', `Barredera`, InputType.SWITCH, { width: 3 }),
                this.field('cepillado', `Cepillado Paredes/Fondo`, InputType.SWITCH, { width: 3 }),
                this.field('limpieza_red', `Limpieza con Red`, InputType.SWITCH, { width: 3 }),
                this.field('rascado_linea_flotacion', `Rascado Línea Flotación`, InputType.SWITCH, { width: 3 }),
            ] },
            { name: 'Comprobación de parámetros', fields: [
                this.field('comprobar_parametros_ph', `Ph`, InputType.NUMERIC, { width: 3 }),
                this.field('comprobar_parametros_cloro', `Cloro`, InputType.NUMERIC, { width: 3 }),
                this.field('comprobar_parametros_acido_isocianurico', `Acido Isocianurico`, InputType.NUMERIC, { width: 3 }),
                this.field('comprobar_parametros_alcalinidad', `Alcalinidad`, InputType.NUMERIC, { width: 3 }),
                this.field('comprobar_parametros_fosfatos', `Fosfatos`, InputType.NUMERIC, { width: 3 }),
                this.field('comprobar_parametros_observaciones', `Observaciones`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Limpieza y mantenimiento', fields: [
                this.field('lavado_enjuague_cesti', `Lavado/Enjuague/Cesto Bomba`, InputType.SWITCH, { width: 3 }),
                this.field('limpieza_duchas', `Limpieza Duchas`, InputType.SWITCH, { width: 3 }),
                this.field('limpieza_skimmer', `Limpieza Skimmer`, InputType.SWITCH, { width: 3 }),
                this.field('nivel_vaso', `Nivel del Vaso`, InputType.SWITCH, { width: 3 }),
                this.field('limpieza_cuarto_depuradora', `Limpieza Cuarto Depuradora`, InputType.SWITCH, { width: 3 }),
            ] },
            { name: 'Cloro', fields: [
                this.field('cloro_liquido', `Líquido (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('cloro_granulado', `Granulado (kilos)`, InputType.NUMERIC, { width: 3 }),
                this.field('cloro_pastillas', `Pastillas`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Floculante', fields: [
                this.field('floculante_liquido', `Líquido (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('floculante_pastillas', `Pastillas`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Productos', fields: [
                this.field('coagulante', `Coagulante (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('algicida', `Algicida (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('alcalinidad', `Alcalinidad (kg)`, InputType.NUMERIC, { width: 3 }),
                this.field('ph_minus', `PH- (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('ph_plus', `PH+ (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('activador', `Activador (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('enzimatic', `Enzimatic (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('desincrustante', `Desincrustante (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('eliminador_fosfatos', `Eliminador Fosfatos (kg)`, InputType.NUMERIC, { width: 3 }),
            ] },
            { name: 'Recambios', fields: [
                this.field('arena_silice', `Arena Sílice (25kg)`, InputType.NUMERIC, { width: 3 }),
                this.field('limpiador_silex', `Limpiador Silex (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('vidrio', `Vidrio (20kg)`, InputType.NUMERIC, { width: 3 }),
                this.field('sacos_sal', `Sacos Sal (25kg)`, InputType.NUMERIC, { width: 3 }),
                this.field('limpiador_fotocelulas', `Limpiador Fotocelulas (litros)`, InputType.NUMERIC, { width: 3 }),
                this.field('cesto_skimmer', `Cesto Skimmer`, InputType.NUMERIC, { width: 3 }),
                this.field('tapas_skimmer', `Tapas Skimmer`, InputType.NUMERIC, { width: 3 }),
                this.field('rejillas_sumidero', `Rejillas Sumidero`, InputType.NUMERIC, { width: 3 }),
                this.field('foco_luz', `Foco Luz`, InputType.NUMERIC, { width: 3 }),
                this.field('alcachofa_ducha', `Alcachofa Ducha`, InputType.NUMERIC, { width: 3 }),
                this.field('pomo_sencilla', `Pomo Sencilla`, InputType.NUMERIC, { width: 3 }),
                this.field('pomo_completo', `Pomo Completo`, InputType.NUMERIC, { width: 3 }),
                this.field('red_piscina', `Red Piscina`, InputType.NUMERIC, { width: 3 }),
                this.field('pertiga', `Pertiga`, InputType.NUMERIC, { width: 3 }),
                this.field('bomba', `Bomba`, InputType.NUMERIC, { width: 3 }),
                this.field('cesto_bomba', `Cesto Bomba`, InputType.NUMERIC, { width: 3 }),
                this.field('escalera', `Escalera`, InputType.NUMERIC, { width: 3 }),
                this.field('rejillas_transversales', `Rejillas Transversales`, InputType.NUMERIC, { width: 3 }),
                this.field('impulsores_boquilla', `Impulsores/Boquilla`, InputType.NUMERIC, { width: 3 }),
                this.field('neat_clean', `Neat Clean`, InputType.NUMERIC, { width: 3 }),
                this.field('dosificadores_orp', `Dosificadores ORP`, InputType.NUMERIC, { width: 3 }),
                this.field('dosificadores_ph', `Dosificadores PH`, InputType.NUMERIC, { width: 3 }),
                this.field('sonda_orp', `Sonda ORP`, InputType.NUMERIC, { width: 3 }),
                this.field('sonda_ph', `Sonda PH`, InputType.NUMERIC, { width: 3 }),
                this.field('dosificador_pastillas', `Dosificador Pastillas`, InputType.NUMERIC, { width: 3 }),
                this.field('manometro', `Manómetro`, InputType.NUMERIC, { width: 3 }),
            ] },
            this.workerSection('Profesionales'),
            this.workOrderSection(),
            this.observationSection('Observaciones'),
        ];
    }
}
